import React from 'react'
import { CloseIcon } from '../iconSet/IconSet'
import { SaveDialogPropsTypes } from './PopupTypes'

const SaveDialog = (props: SaveDialogPropsTypes) => {

    const handleYesClick = () => {
        if(props.function){
            props.function()
        }
        props.setWindowState(false)
    }

    return (
        <div className={`workflow-popup`}>
            <div className={`workflow-popup-wrapper`} style={{width: `25rem`}}>
                <div className={`title`}>
                    <span>{props.title}</span>
                    <CloseIcon width='1.2rem' color='var(--color-main-red)' onClick={(e) => props.setWindowState(false)}/>
                </div>
                <div className={`data-wrapper`}>
                    <span className={`message`}>are you sure you want to save?</span>
                    <div className={`button-wrapper`} style={{gridArea: 'buttons'}}>
                        <div className={`left-side`}>
                            <button className={`button-normal`} onClick={(e) => props.setWindowState(false)}>cancel</button>
                        </div>
                        <div className={`right-side`}>
                            <button className={`button-normal`} onClick={(e) => handleYesClick()}>yes</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SaveDialog